import gql from "graphql-tag";
import { shiftTemplateFragment } from '@/graphql/shift/shiftFragments'

export const UPSERTSHIFTTEMPLATE = gql`
    mutation upsertShiftTemplate (
        $id: ID
        $name: String
        $description: String

        $start_time: String
        $end_time: String

        $Sun: Boolean
        $Mon: Boolean
        $Tue: Boolean
        $Wed: Boolean
        $Thu: Boolean
        $Fri: Boolean
        $Sat: Boolean
    ){
        upsertShiftTemplate(
            input: {
                id: $id
                name: $name
                description: $description

                start_time: $start_time
                end_time: $end_time

                Sun: $Sun
                Mon: $Mon
                Tue: $Tue
                Wed: $Wed
                Thu: $Thu
                Fri: $Fri
                Sat: $Sat
            }
        ){
            ...shiftTemplateFragment
        }
    }
    ${shiftTemplateFragment}
`

export const DELETESHIFTTEMPLATE = gql`
    mutation deleteShiftTemplate(
        $id: ID!
    ){
        deleteShiftTemplate(
            id: $id
        ){
            ...shiftTemplateFragment
        }
    }
    ${shiftTemplateFragment}
`

export const RESTORESHIFTTEMPLATES = gql`
    mutation restoreShiftTemplate(
        $id: ID!
    ){
        restoreShiftTemplate(
            id: $id
        ){
            ...shiftTemplateFragment
        }
    }
    ${shiftTemplateFragment}
`